<script>
import DonationAppFeeChangeModal from '@/components/fundraisers/donation-app-fee-change-modal.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwCard from '@/components/generic/tw-card.vue'

export default {
  name: 'FundraiserDonationAppFeeCard' ,
  components: { TwCard, TwButton, DonationAppFeeChangeModal },
  props: {
    modelValue: {
      type: Number,
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      EditorActive: false
    }
  },
  methods: {
    update(val) {
      this.$emit('update:modelValue', val)
      this.EditorActive = false
    }
  }
}
</script>

<template>
  <tw-card class="bg-orange-100 text-sm shadow-sm">
    <div v-if="EditorActive">
      <h6>
        Your optional contribution helps keep GroupRev Free
      </h6>
      <div class="mt-4 grid grid-cols-4 gap-2">
        <tw-button block variant="white" @click="update(9)">
          $9
        </tw-button>
        <tw-button block variant="white" @click="update(5)">
          $5
        </tw-button>
        <tw-button block variant="white" @click="update(3)">
          $3
        </tw-button>
        <tw-button block variant="white" @click="$refs.DonationAppFeeChangeModal.open()">
          Other
        </tw-button>
      </div>
    </div>
    <div v-else>
      <div class="font-bold">
        + <span v-if="modelValue > 0">${{ modelValue }}</span> Optional Contribution
      </div>
      <div class="flex flex-col gap-4 mt-4">
        <span>GroupRev is a free platform enabling organizations to raise millions for causes and projects that impact the world. We rely on the generosity of small contributions like this to maintain the service.</span>
        <tw-button variant="link" @click="EditorActive = !EditorActive" class="underline text-xs">
          Edit Amount
        </tw-button>
      </div>
    </div>
    <donation-app-fee-change-modal ref="DonationAppFeeChangeModal" @update:model-value="update($event)" />
  </tw-card>
</template>

<style scoped>

</style>
